import { GridColumn as Column } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import * as React from "react";
import { useContext } from "react";
import TimeCell from "./TimeCell";
import RouteCell from "./RouteCell/RouteCell";
import { EditProjectContext } from "../../../EditProjectContext";
import { ProjectState } from "../../../../ViewModel/ProjectState";
import { ReadOnlyProps } from "../../../ReadOnlyProps";

export default function LtlTabTableColumns({ isReadOnly }: ReadOnlyProps) {
  const { project } = useContext(EditProjectContext);
  const editable = project.State === ProjectState.Sandbox;
  return [
    <Column
      key="Route.RouteDisplayName"
      field="Route.RouteDisplayName"
      title="Route"
      filter="text"
      cell={RouteCell}
      editable={editable}
      resizable
    />,
    <Column
      key="Carrier"
      field="Carrier"
      title="Carrier"
      filter="text"
      editable={false}
      resizable
    />,
    <Column
      key="NextDestination"
      field="NextDestination"
      title="Next Destination"
      filter="text"
      editable={false}
      resizable
    />,
    <Column
      key="TransitDays"
      field="TransitDays"
      title="Transit Days"
      filter="text"
      editable={false}
      resizable
    />,
    <Column
      key="ArrivalDay"
      field="ArrivalDay"
      title="Arrival Day"
      filter="text"
      editable={false}
      resizable
    />,
    <Column
      key="ArrivalTime"
      field="ArrivalTime"
      title="Arrival Time"
      filter="date"
      cell={TimeCell}
      editable={false}
      resizable
    />,
    <Column
      key="ODCHandlingTime"
      field="ODCHandlingTime"
      title="ODC Handling Time"
      filter="date"
      editable={false}
      resizable
    />,
    <Column
      key="OutboundDay"
      field="OutboundDay"
      title="Outbound Day"
      filter="text"
      editable={false}
      resizable
    />,
    <Column
      key="DepartureTime"
      field="DepartureTime"
      title="Est. Dep. Time"
      filter="date"
      cell={TimeCell}
      editable={false}
      resizable
    />,
    <Column
      key="ActualDepartureTime"
      field="ActualDepartureTime"
      title="Act. Dep. Time"
      filter="date"
      cell={TimeCell}
      editable={false}
      resizable
    />,
    <Column
      key="Km"
      field="Km"
      title="Km"
      editor="numeric"
      editable={editable && !isReadOnly}
      resizable
    />,
  ];
}
